export class StudisuError extends Error {
  constructor(
    message: string,
    public cause: Error
  ) {
    super(message);
    this.name = 'StudisuError';
    this.stack += `\nCaused by: ${cause.name} ${cause.message}\n` + cause.stack;
  }
}
